import {Component, Input, OnInit} from '@angular/core';
import {LicensingTierTemplate} from '../../interface/licensingTier.interface';
import {LicenseState} from '../../../../services/licensing.interfaces';
import {MatDialogRef} from '@angular/material/dialog';
import {LicensingRenewalDialogComponent} from '../../licensing-renewal-dialog.component';
import {BaseLicensingInfoComponent} from '../base-licensing-info/base-licensing-info.component';
import {DatePipe} from '@angular/common';
import {AppUser, AuthService} from '../../../../../../core/modules/auth/services/auth.service';
import {LocalStorageService} from '../../../../../../core/localStorage/local-storage.service';
import {CustomerService} from '../../../../../../core/modules/auth/services/customer.service';

@Component({
  selector: 'app-consultant-licensing-info',
  templateUrl: './consultant-licensing-info.component.html',
  styleUrls: ['../../licensing-renewal-dialog.component.scss']
})
export class ConsultantLicensingInfoComponent extends BaseLicensingInfoComponent implements OnInit, LicensingTierTemplate {

  @Input() data: {
    licenseState: LicenseState;
    activeUser: AppUser;
    dialogRef: MatDialogRef<LicensingRenewalDialogComponent>;
  };

  constructor( public datePipe: DatePipe,
               public localStorageService: LocalStorageService,
               public authService: AuthService,
               public customerService: CustomerService) {
    super( datePipe, localStorageService, authService, customerService);
  }

  ngOnInit(): void {
    this.sourceData = this.data;
    super.ngOnInit();
    this.checkMuteStatus();
    this.buildTemplateData(this.sourceData.licenseState);
  }

  buildTemplateData(licenseState: LicenseState): void{

    const expiryPrefix = `Your license for ${licenseState.license.domain}`;
    let expiryMessage = '';
    if (licenseState.expiresIn < 0) {
      expiryMessage = `${expiryPrefix} has expired`;
    }
    if (licenseState.expiresIn === 0) {
      expiryMessage = `${expiryPrefix} expires today`;
    }
    console.log('licenseState.expiresIn', licenseState.expiresIn);
    if (licenseState.expiresIn === 1) {
      expiryMessage = `${expiryPrefix} expires in 1 day`;
    }

    if (licenseState.expiresIn > 1) {
      expiryMessage = `${expiryPrefix} will expire in ${licenseState.expiresIn} days`;
    }

    if(licenseState.bundle === 'ait-atu') {
      expiryMessage += ' as part of your <b>Admin Tools Unlimited</b> subscription.';
    } else {
      expiryMessage += '.';
    }

    this.templateData = {
      domain: licenseState.license.domain,
      expireDays: licenseState.expiresIn,
      expireDate: this.datePipe.transform(licenseState.license.subscriptions['ait-lsp'].expiry, 'MM/dd/yyyy'),
      expiryMessage,
      showIcon: (licenseState.expiresIn <= 7),
      plan: 'Consultant'
    };

  }

}
